import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { ActionAnchor, ActionLink, Container, DraftTag, Eyebrow } from "@/components/site/primitives";
import { HeroStructure } from "./HeroStructure";

const LEDGER = [
  { to: "/ordo", label: "General Ordo", note: "A governing architecture", testid: "ledger-ordo" },
  { to: "/enterprise/software", label: "Four applied capabilities", note: "Engine · Stewardship · Breakpoint · Mesh", testid: "ledger-software" },
  { to: "/enterprise/diagnostic", label: "Ordo Diagnostic", note: "The customer entrance", testid: "ledger-diagnostic" },
  { to: "/research", label: "Three independent products", note: "Briefcase · Forma · Lumen", testid: "ledger-products" },
];

const Ledger = () => (
  <div className="fade-up delay-4 border-t border-o-line pb-12 pt-6" data-testid="home-ledger">
    <div className="mb-5 flex items-center justify-between gap-3 font-mono text-[10.5px] uppercase tracking-[0.22em] text-o-dim">
      <span>What has been developed</span>
      <DraftTag />
    </div>
    <ul className="grid gap-px bg-o-line sm:grid-cols-2 lg:grid-cols-4">
      {LEDGER.map((l, i) => (
        <li key={l.to} className="bg-o-bg">
          <Link to={l.to} data-testid={l.testid} className="group flex h-full flex-col justify-between gap-8 p-5 transition-colors hover:bg-o-surface">
            <span className="flex items-center justify-between font-mono text-[11px] text-o-accent">
              0{i + 1}
              <ArrowUpRight className="h-4 w-4 text-o-dim transition-[transform,color] group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-o-accent" />
            </span>
            <span>
              <span className="block font-display text-xl font-bold leading-tight">{l.label}</span>
              <span className="mt-1 block text-sm text-o-dim">{l.note}</span>
            </span>
          </Link>
        </li>
      ))}
    </ul>
  </div>
);

export const Entrance = () => (
  <section data-testid="home-entrance" className="t-ink grain relative overflow-hidden bg-o-bg text-o-text">
    <div aria-hidden className="blueprint blueprint-fade pointer-events-none absolute inset-0 opacity-80" />
    <Container className="relative">
      <div className="grid items-center gap-12 pb-14 pt-14 sm:pt-20 lg:grid-cols-12 lg:gap-8 lg:pb-16 lg:pt-20">
        <div className="lg:col-span-7">
          <Eyebrow index="00" className="fade-up">Research · Diagnostics · Software · Products</Eyebrow>
          <h1 data-testid="home-headline" className="fade-up delay-1 mt-8 max-w-[17ch] font-display text-4xl font-extrabold leading-[1.02] tracking-[-0.02em] sm:text-5xl lg:text-6xl">
            As intelligence becomes more capable, <span className="text-o-accent">its structure becomes decisive.</span>
          </h1>
          <p className="fade-up delay-2 mt-8 max-w-xl text-base leading-relaxed text-o-dim sm:text-lg">
            Ordo Intelligence is a research, diagnostics, software, and product-development company built around understanding and improving human structure: how people, responsibilities, technology, knowledge, authority, and intelligence are arranged around human purposes.
          </p>
          <div className="fade-up delay-3 mt-10 flex flex-wrap gap-3">
            <ActionAnchor href="#foundation" testid="hero-explore-btn">Explore the developed work</ActionAnchor>
            <ActionLink to="/engage?from=%2F" variant="line" testid="hero-engage-btn">Begin a conversation</ActionLink>
          </div>
        </div>
        <div className="fade-up delay-2 mx-auto w-full max-w-md lg:col-span-5 lg:max-w-none">
          <HeroStructure />
        </div>
      </div>
      <Ledger />
    </Container>
  </section>
);
